// RefreshObservable.js
import { Subject } from "rxjs";

const refresh$ = new Subject();

export const EventEmitter = (payload) => refresh$.next(payload);

export const OnRefresh = () => refresh$.asObservable();
